import 'css-chunksrc/client/common/roleSelection/styles.scss';export default {
  "roleSelection": "_roleSelection_fwubr_1",
  "input": "_input_fwubr_5",
  "openedInput": "_openedInput_fwubr_22",
  "iconOpen": "_iconOpen_fwubr_28",
  "iconClose": "_iconClose_fwubr_39",
  "listRoot": "_listRoot_fwubr_47",
  "list": "_list_fwubr_47",
  "role": "_role_fwubr_1",
  "selectedRole": "_selectedRole_fwubr_71",
  "selectedRoleIcon": "_selectedRoleIcon_fwubr_75",
  "selectedRoleTitle": "_selectedRoleTitle_fwubr_81",
  "roleDescription": "_roleDescription_fwubr_88",
  "selectedRoles": "_selectedRoles_fwubr_93",
  "placeholder": "_placeholder_fwubr_99"
};